import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const OutboundSOAddProductRBAC = {
  pageID: '18859a09527f155eb9e140086e487474',
  elementID: {
    ButtonSubmit: '065c4c8549d46c30c62225dc0d0cde68',
  },
} as const

export const useRBACOutboundSOAddProductPage = createUseRBAC(OutboundSOAddProductRBAC.elementID)
export type UseRBACOutboundSOAddProductPageType = ReturnType<typeof useRBACOutboundSOAddProductPage>
